import { getRolePermissionsInstance } from "./RolePermissionsFactory";
import type { RolePermissionsMatrixApiResponse } from "./RolePermissionsTypes";

export type {
	PermissionContextAclEntryDto,
	PermissionContextDto,
	PermissionContextScopeDto,
	PermissionsSupportClientMatrixViewBody,
	RolePermissionsMatrixApiEntry,
	RolePermissionsMatrixApiResponse,
	RolePermissionsWithContextApiResponse,
} from "./RolePermissionsTypes";

export interface IRolePermissions {
	getMatrix(): Promise<RolePermissionsMatrixApiResponse>;
}

export const RolePermissions = {
	getInstance: (): IRolePermissions => {
		return getRolePermissionsInstance();
	},
};

export default RolePermissions;
